import React from 'react';
import style from './SubMenuTitle.scss';
import { Text } from '../../PageElements/Text';

export const SubMenuTitle = ({ children }) => {
  return (
    <Text
      dataHook="sub-menu-title"
      secondary
      className={style.subMenuTitle}
      tagName="span"
    >
      {children}
    </Text>
  );
};
